import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import logoAmancio from './amancio.png';

const ADMIN = { username: 'amancio', password: 'admin123' };

const inputSt = { width: '100%', padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #e2e8f0', fontSize: '13px', color: '#1e293b', outline: 'none', boxSizing: 'border-box', background: '#fff' };
const labelSt = { display: 'block', color: '#475569', fontSize: '11px', fontWeight: '700', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.5px' };

function AdminLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setTimeout(() => {
      if (username === ADMIN.username && password === ADMIN.password) {
        onLogin();
      } else {
        setError('Incorrect username or password.');
      }
      setLoading(false);
    }, 600);
  };

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a, #1e293b, #0f4c35)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Georgia, serif', padding: '20px' }}>
      <div style={{ background: 'rgba(255,255,255,0.04)', backdropFilter: 'blur(20px)', border: '1px solid rgba(16,185,129,0.2)', borderRadius: '20px', padding: '48px 40px', width: '100%', maxWidth: '400px', boxShadow: '0 25px 60px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={logoAmancio} alt="Amancio Remodeling" style={{ height: '64px', margin: '0 auto 14px', display: 'block' }} />
          <h1 style={{ color: '#10b981', fontSize: '18px', fontWeight: 'bold', margin: '0 0 4px' }}>Admin Portal</h1>
          <p style={{ color: '#64748b', fontSize: '13px', margin: 0 }}>Amancio Remodeling</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: '12px', fontWeight: '600', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Username</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} required placeholder="admin username"
              style={{ width: '100%', padding: '11px 14px', borderRadius: '8px', border: '1px solid rgba(16,185,129,0.3)', background: 'rgba(255,255,255,0.05)', color: '#f1f5f9', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#94a3b8', fontSize: '12px', fontWeight: '600', marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="password"
              style={{ width: '100%', padding: '11px 14px', borderRadius: '8px', border: '1px solid rgba(16,185,129,0.3)', background: 'rgba(255,255,255,0.05)', color: '#f1f5f9', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }} />
          </div>
          {error && <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', color: '#f87171', fontSize: '13px', textAlign: 'center' }}>⚠️ {error}</div>}
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '13px', borderRadius: '10px', background: loading ? 'rgba(16,185,129,0.5)' : 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '15px', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Verifying...' : '🔐 Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

function PortalHeader({ title, onBack, backLabel, children }) {
  return (
    <header style={{ background: '#0f172a', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <img src={logoAmancio} alt="Amancio" style={{ height: '38px' }} />
        <p style={{ color: '#f1f5f9', fontSize: '15px', fontWeight: 'bold', margin: 0 }}>{title}</p>
      </div>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        {children}
        {onBack && (
          <button onClick={onBack}
            style={{ padding: '8px 16px', borderRadius: '8px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: '#cbd5e1', fontSize: '13px', cursor: 'pointer' }}>
            {backLabel || '← Back'}
          </button>
        )}
      </div>
    </header>
  );
}

function Dashboard({ onNavigate, onLogout }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <header style={{ background: '#0f172a', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 4px 20px rgba(0,0,0,0.3)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src={logoAmancio} alt="Amancio" style={{ height: '38px' }} />
          <div>
            <p style={{ color: '#10b981', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', margin: 0 }}>Admin Portal</p>
            <p style={{ color: '#f1f5f9', fontSize: '14px', fontWeight: 'bold', margin: 0 }}>Amancio Remodeling</p>
          </div>
        </div>
        <button onClick={onLogout}
          style={{ padding: '8px 16px', borderRadius: '8px', background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.3)', color: '#f87171', fontSize: '12px', cursor: 'pointer', fontWeight: '600' }}>
          Sign Out
        </button>
      </header>
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '32px 24px' }}>
        <h1 style={{ color: '#0f172a', fontSize: '24px', fontWeight: 'bold', margin: '0 0 24px' }}>Welcome, Amancio 👋</h1>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          {[
            { id: 'estimates', icon: '📋', title: 'Estimates', desc: 'Create, view and manage all your project estimates' },
            { id: 'clients', icon: '👥', title: 'Clients', desc: 'Register clients and view their estimate history' },
            { id: 'gallery', icon: '🖼️', title: 'Gallery', desc: 'Upload and manage photos shown on the website\'s Our Work section' },
          ].map(card => (
            <button key={card.id} onClick={() => onNavigate(card.id)}
              style={{ background: '#fff', border: '2px solid #e2e8f0', borderRadius: '16px', padding: '28px', textAlign: 'left', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.04)', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#10b981'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(16,185,129,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)'; }}>
              <p style={{ fontSize: '36px', margin: '0 0 12px' }}>{card.icon}</p>
              <h3 style={{ color: '#0f172a', fontSize: '18px', fontWeight: 'bold', margin: '0 0 6px' }}>{card.title}</h3>
              <p style={{ color: '#64748b', fontSize: '13px', margin: '0 0 14px', lineHeight: '1.5' }}>{card.desc}</p>
              <span style={{ color: '#10b981', fontSize: '13px', fontWeight: '600' }}>Go to {card.title} →</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

function ClientList({ onNew, onView, onBack }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { fetchClients(); }, []);

  const fetchClients = async () => {
    setLoading(true);
    const { data } = await supabase.from('clients').select('*').order('created_at', { ascending: false });
    setClients(data || []);
    setLoading(false);
  };

  const deleteClient = async (id) => {
    if (!window.confirm('Delete this client? Their estimates will remain in the system.')) return;
    await supabase.from('clients').delete().eq('id', id);
    fetchClients();
  };

  const filtered = clients.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.email?.toLowerCase().includes(search.toLowerCase()) ||
    c.phone?.includes(search)
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title="Clients" onBack={onBack} backLabel="← Dashboard">
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search clients..."
          style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.08)', color: '#f1f5f9', fontSize: '13px', outline: 'none', width: '200px' }} />
        <button onClick={onNew}
          style={{ padding: '8px 20px', borderRadius: '8px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
          + New Client
        </button>
      </PortalHeader>
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '28px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>Loading clients...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <p style={{ fontSize: '40px', margin: '0 0 12px' }}>👥</p>
            <p style={{ fontSize: '16px', color: '#475569', fontWeight: '600', margin: '0 0 6px' }}>No clients yet</p>
            <p style={{ fontSize: '13px', margin: 0 }}>Click "New Client" to add your first one</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {filtered.map(client => (
              <div key={client.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '18px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '44px', height: '44px', borderRadius: '50%', background: 'linear-gradient(135deg, #10b981, #059669)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '18px', fontWeight: 'bold', flexShrink: 0 }}>
                    {client.name?.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <p style={{ color: '#0f172a', fontSize: '15px', fontWeight: 'bold', margin: '0 0 3px' }}>{client.name}</p>
                    <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 2px' }}>{client.email || 'No email'} {client.phone ? `· ${client.phone}` : ''}</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>{client.address || 'No address'}</p>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => onView(client.id)}
                    style={{ padding: '7px 16px', borderRadius: '8px', background: 'linear-gradient(135deg, #3b82f6, #2563eb)', border: 'none', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                    View
                  </button>
                  <button onClick={() => deleteClient(client.id)}
                    style={{ padding: '7px 12px', borderRadius: '8px', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', color: '#ef4444', fontSize: '12px', cursor: 'pointer' }}>
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function ClientForm({ clientId, onSaved, onBack }) {
  const [form, setForm] = useState({ name: '', phone: '', email: '', address: '' });
  const [saving, setSaving] = useState(false);
  const isEdit = !!clientId;

  useEffect(() => {
    if (clientId) {
      supabase.from('clients').select('*').eq('id', clientId).single()
        .then(({ data }) => { if (data) setForm(data); });
    }
  }, [clientId]);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSave = async () => {
    if (!form.name) { alert('Name is required.'); return; }
    setSaving(true);

    let error;
    if (isEdit) {
      ({ error } = await supabase.from('clients').update({
        name: form.name, phone: form.phone, email: form.email, address: form.address
      }).eq('id', clientId));
    } else {
      ({ error } = await supabase.from('clients').insert({
        name: form.name, phone: form.phone, email: form.email, address: form.address
      }));
    }

    setSaving(false);

    if (error) {
      alert('Error: ' + error.message);
      return;
    }

    onSaved();
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title={isEdit ? 'Edit Client' : 'New Client'} onBack={onBack} />
      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '28px 24px' }}>
        <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
          <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: '0 0 20px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>👤 Client Information</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
            <div><label style={labelSt}>Full Name *</label><input style={inputSt} value={form.name} onChange={e => set('name', e.target.value)} placeholder="John Smith" /></div>
            <div><label style={labelSt}>Phone</label><input style={inputSt} value={form.phone || ''} onChange={e => set('phone', e.target.value)} placeholder="(702) 000-0000" /></div>
            <div><label style={labelSt}>Email</label><input style={inputSt} type="email" value={form.email || ''} onChange={e => set('email', e.target.value)} placeholder="john@example.com" /></div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={labelSt}>Address</label>
            <input style={inputSt} value={form.address || ''} onChange={e => set('address', e.target.value)} placeholder="123 Main St, Las Vegas, NV" />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
            <button onClick={onBack}
              style={{ padding: '13px', borderRadius: '10px', background: '#fff', border: '2px solid #e2e8f0', color: '#64748b', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
              Cancel
            </button>
            <button onClick={handleSave} disabled={saving}
              style={{ padding: '13px', borderRadius: '10px', background: saving ? 'rgba(16,185,129,0.5)' : 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '15px', fontWeight: 'bold', cursor: saving ? 'not-allowed' : 'pointer' }}>
              {saving ? '⏳ Saving...' : isEdit ? '💾 Save Changes' : '💾 Register Client'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ClientDetail({ clientId, onBack, onNewEstimate, onViewEstimate }) {
  const [client, setClient] = useState(null);
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchData(); }, [clientId]);

  const fetchData = async () => {
    setLoading(true);
    const [{ data: c }, { data: e }] = await Promise.all([
      supabase.from('clients').select('*').eq('id', clientId).single(),
      supabase.from('estimates').select('*').eq('client_id', clientId).order('created_at', { ascending: false }),
    ]);
    setClient(c);
    setEstimates(e || []);
    setLoading(false);
  };

  if (editing) return <ClientForm clientId={clientId} onSaved={() => { setEditing(false); fetchData(); }} onBack={() => setEditing(false)} />;
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Georgia, serif', color: '#94a3b8' }}>Loading...</div>;
  if (!client) return null;

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title={client.name} onBack={onBack} backLabel="← Clients">
        <button onClick={() => setEditing(true)}
          style={{ padding: '8px 18px', borderRadius: '8px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)', color: '#cbd5e1', fontSize: '13px', cursor: 'pointer' }}>
          ✏️ Edit
        </button>
        <button onClick={() => onNewEstimate(clientId)}
          style={{ padding: '8px 20px', borderRadius: '8px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
          + New Estimate
        </button>
      </PortalHeader>
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '28px 24px' }}>
        <div style={{ background: '#fff', borderRadius: '14px', padding: '24px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', marginBottom: '24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
            {[
              { label: 'Phone', value: client.phone || '—' },
              { label: 'Email', value: client.email || '—' },
              { label: 'Address', value: client.address || '—' },
            ].map(({ label, value }) => (
              <div key={label}>
                <p style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', margin: '0 0 4px' }}>{label}</p>
                <p style={{ color: '#1e293b', fontSize: '14px', fontWeight: '500', margin: 0 }}>{value}</p>
              </div>
            ))}
          </div>
        </div>
        <h2 style={{ color: '#0f172a', fontSize: '16px', fontWeight: 'bold', margin: '0 0 14px' }}>Estimate History ({estimates.length})</h2>
        {estimates.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#94a3b8', background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            No estimates for this client yet.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {estimates.map(est => (
              <div key={est.id} onClick={() => onViewEstimate(est.id)}
                style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}
                onMouseEnter={e => e.currentTarget.style.borderColor = '#10b981'}
                onMouseLeave={e => e.currentTarget.style.borderColor = '#e2e8f0'}>
                <div>
                  <p style={{ color: '#0f172a', fontSize: '14px', fontWeight: 'bold', margin: '0 0 3px' }}>{est.folio} — {est.type}</p>
                  <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>{new Date(est.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                </div>
                <p style={{ color: '#059669', fontSize: '16px', fontWeight: 'bold', margin: 0 }}>${parseFloat(est.total).toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function EstimateList({ onNew, onView, onBack }) {
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => { fetchEstimates(); }, []);

  const fetchEstimates = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('estimates').select('*, clients(name)')
      .order('created_at', { ascending: false });
    setEstimates(data || []);
    setLoading(false);
  };

  const deleteEstimate = async (id) => {
    if (!window.confirm('Delete this estimate?')) return;
    await supabase.from('estimates').delete().eq('id', id);
    fetchEstimates();
  };

  const filtered = estimates.filter(e => {
    const clientName = e.client_name || e.clients?.name || '';
    return (
      clientName.toLowerCase().includes(search.toLowerCase()) ||
      e.folio?.toLowerCase().includes(search.toLowerCase()) ||
      e.type?.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title="Estimates" onBack={onBack} backLabel="← Dashboard">
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search..."
          style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.2)', background: 'rgba(255,255,255,0.08)', color: '#f1f5f9', fontSize: '13px', outline: 'none', width: '200px' }} />
        <button onClick={onNew}
          style={{ padding: '8px 20px', borderRadius: '8px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
          + New Estimate
        </button>
      </PortalHeader>
      <div style={{ maxWidth: '960px', margin: '0 auto', padding: '28px 24px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>Loading estimates...</div>
        ) : filtered.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8' }}>
            <p style={{ fontSize: '40px', margin: '0 0 12px' }}>📋</p>
            <p style={{ fontSize: '16px', color: '#475569', fontWeight: '600', margin: '0 0 6px' }}>No estimates yet</p>
            <p style={{ fontSize: '13px', margin: 0 }}>Click "New Estimate" to create your first one</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {filtered.map(est => (
              <div key={est.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '18px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ background: 'linear-gradient(135deg, #0f172a, #1e293b)', borderRadius: '10px', padding: '10px 14px', textAlign: 'center', minWidth: '70px' }}>
                    <p style={{ color: '#10b981', fontSize: '11px', fontWeight: 'bold', margin: '0 0 2px', textTransform: 'uppercase' }}>Folio</p>
                    <p style={{ color: '#f1f5f9', fontSize: '13px', fontWeight: 'bold', margin: 0 }}>{est.folio}</p>
                  </div>
                  <div>
                    <p style={{ color: '#0f172a', fontSize: '15px', fontWeight: 'bold', margin: '0 0 3px' }}>{est.client_name || est.clients?.name}</p>
                    <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 2px' }}>{est.type}</p>
                    <p style={{ color: '#94a3b8', fontSize: '11px', margin: 0 }}>{new Date(est.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <p style={{ color: '#059669', fontSize: '18px', fontWeight: 'bold', margin: 0 }}>${parseFloat(est.total).toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
                  <button onClick={() => onView(est.id)}
                    style={{ padding: '7px 16px', borderRadius: '8px', background: 'linear-gradient(135deg, #3b82f6, #2563eb)', border: 'none', color: 'white', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
                    View
                  </button>
                  <button onClick={() => deleteEstimate(est.id)}
                    style={{ padding: '7px 12px', borderRadius: '8px', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', color: '#ef4444', fontSize: '12px', cursor: 'pointer' }}>
                    🗑️
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function EstimateForm({ estimateId, preselectedClientId, onSaved, onBack }) {
  const isEdit = !!estimateId;
  const [step, setStep] = useState(1);
  const [saving, setSaving] = useState(false);
  const [clients, setClients] = useState([]);

  const [clientId, setClientId] = useState(preselectedClientId || '');
  const [type, setType] = useState('Kitchen Remodel');
  const [notes, setNotes] = useState('');
  const [terms, setTerms] = useState('• This is a preliminary estimate. Final price may vary after on-site inspection.\n• Estimate valid for 30 days from date of issue.\n• A 30% deposit is required to begin work.\n• Scope changes may affect the final cost.');
  const [startDate, setStartDate] = useState('');
  const [finishDate, setFinishDate] = useState('');
  const [materials, setMaterials] = useState([{ item: '', description: '', quantity: '', unit_price: '' }]);
  const [labor, setLabor] = useState([{ service: '', description: '', quantity: '', cost: '' }]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    supabase.from('clients').select('id, name, email, phone, address').order('name').then(({ data }) => setClients(data || []));
    if (isEdit) loadEstimate(); // eslint-disable-line
  }, [estimateId]); // eslint-disable-line

  const loadEstimate = async () => {
    const [{ data: est }, { data: mats }, { data: lab }] = await Promise.all([
      supabase.from('estimates').select('*').eq('id', estimateId).single(),
      supabase.from('estimate_materials').select('*').eq('estimate_id', estimateId),
      supabase.from('estimate_labor').select('*').eq('estimate_id', estimateId),
    ]);
    if (est) {
      setClientId(est.client_id || '');
      setType(est.type || '');
      setNotes(est.notes || '');
      setTerms(est.terms || terms);
      setStartDate(est.start_date || '');
      setFinishDate(est.finish_date || '');
    }
    if (mats?.length) setMaterials(mats.map(m => ({ item: m.item, description: m.description || '', quantity: m.quantity, unit_price: m.unit_price })));
    if (lab?.length) setLabor(lab.map(l => ({ service: l.service, description: l.description || '', quantity: l.quantity, cost: l.cost })));
  };

  const selectedClient = clients.find(c => c.id === clientId);
  const updateMaterial = (i, k, v) => { const r = [...materials]; r[i] = { ...r[i], [k]: v }; setMaterials(r); };
  const updateLabor = (i, k, v) => { const r = [...labor]; r[i] = { ...r[i], [k]: v }; setLabor(r); };
  const materialsTotal = materials.reduce((s, r) => s + (parseFloat(r.quantity) || 0) * (parseFloat(r.unit_price) || 0), 0);
  const laborTotal = labor.reduce((s, r) => s + (parseFloat(r.quantity) || 0) * (parseFloat(r.cost) || 0), 0);
  const grandTotal = materialsTotal + laborTotal;

  const handleSave = async () => {
    if (!clientId) { alert('Please select a client.'); return; }
    setSaving(true);
    const { data: folioData } = await supabase.rpc('next_folio');
    const folio = isEdit ? undefined : folioData;
    const clientData = clients.find(c => c.id === clientId);
    const payload = {
      client_id: clientId,
      client_name: clientData?.name,
      client_email: clientData?.email,
      client_phone: clientData?.phone,
      client_address: clientData?.address,
      type, notes, terms,
      start_date: startDate || null,
      finish_date: finishDate || null,
      total: grandTotal,
    };

    let estId = estimateId;
    if (isEdit) {
      await supabase.from('estimates').update(payload).eq('id', estimateId);
      await supabase.from('estimate_materials').delete().eq('estimate_id', estimateId);
      await supabase.from('estimate_labor').delete().eq('estimate_id', estimateId);
    } else {
      const { data: est } = await supabase.from('estimates').insert({ ...payload, folio }).select().single();
      estId = est.id;
    }

    const validMats = materials.filter(r => r.item && r.quantity && r.unit_price);
    if (validMats.length > 0) await supabase.from('estimate_materials').insert(validMats.map(r => ({ estimate_id: estId, item: r.item, description: r.description, quantity: parseFloat(r.quantity), unit_price: parseFloat(r.unit_price) })));

    const validLab = labor.filter(r => r.service && r.quantity && r.cost);
    if (validLab.length > 0) await supabase.from('estimate_labor').insert(validLab.map(r => ({ estimate_id: estId, service: r.service, description: r.description, quantity: parseFloat(r.quantity), cost: parseFloat(r.cost) })));

    setSaving(false);
    onSaved(estId);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title={isEdit ? 'Edit Estimate' : 'New Estimate'} onBack={onBack} />
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '28px 24px' }}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '24px' }}>
          {[{ n: 1, l: 'Client & Project' }, { n: 2, l: 'Materials & Labor' }, { n: 3, l: 'Terms & Conditions' }].map(s => (
            <button key={s.n} onClick={() => setStep(s.n)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 18px', borderRadius: '10px', background: step === s.n ? 'linear-gradient(135deg, #10b981, #059669)' : '#fff', border: '1.5px solid', borderColor: step === s.n ? '#10b981' : '#e2e8f0', cursor: 'pointer' }}>
              <span style={{ width: '22px', height: '22px', borderRadius: '50%', background: step === s.n ? 'rgba(255,255,255,0.2)' : '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', color: step === s.n ? '#fff' : '#64748b' }}>{s.n}</span>
              <span style={{ fontSize: '13px', fontWeight: '600', color: step === s.n ? '#fff' : '#64748b' }}>{s.l}</span>
            </button>
          ))}
        </div>

        {step === 1 && (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
            <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: '0 0 20px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>👤 Select Client</h2>
            <div style={{ marginBottom: '20px' }}>
              <label style={labelSt}>Client *</label>
              <select style={{ ...inputSt, cursor: 'pointer' }} value={clientId} onChange={e => setClientId(e.target.value)}>
                <option value="">-- Select a client --</option>
                {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
              {selectedClient && <p style={{ color: '#10b981', fontSize: '12px', marginTop: '6px', fontWeight: '600' }}>✓ Selected: {selectedClient.name}</p>}
            </div>
            <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: '20px 0 14px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>📋 Project Info</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px', marginBottom: '14px' }}>
              <div>
                <label style={labelSt}>Project Type</label>
                <select style={{ ...inputSt, cursor: 'pointer' }} value={type} onChange={e => setType(e.target.value)}>
                  <option>Kitchen Remodel</option>
                  <option>Bathroom Remodel</option>
                  <option>Flooring Installation</option>
                  <option>General Construction</option>
                  <option>Landscaping</option>
                  <option>Full Renovation</option>
                  <option>Painting</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label style={labelSt}>Start Date</label>
                <input style={inputSt} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
              </div>
              <div>
                <label style={labelSt}>Est. Finish Date</label>
                <input style={inputSt} type="date" value={finishDate} onChange={e => setFinishDate(e.target.value)} />
              </div>
            </div>
            <div>
              <label style={labelSt}>Scope of Work / Notes</label>
              <textarea style={{ ...inputSt, minHeight: '90px', resize: 'vertical' }} value={notes} onChange={e => setNotes(e.target.value)} placeholder="Describe the scope of work..." />
            </div>
            <button onClick={() => setStep(2)}
              style={{ marginTop: '20px', width: '100%', padding: '13px', borderRadius: '10px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer' }}>
              Next: Materials & Labor →
            </button>
          </div>
        )}

        {step === 2 && (
          <div>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>
                <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: 0 }}>🧱 Materials</h2>
                <button onClick={() => setMaterials(p => [...p, { item: '', description: '', quantity: '', unit_price: '' }])}
                  style={{ padding: '6px 14px', borderRadius: '8px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#059669', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>
                  + Add Row
                </button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1.2fr 1fr 36px', gap: '8px', marginBottom: '8px' }}>
                {['Item', 'Description', 'Qty', 'Unit Price', 'Total', ''].map(h => (
                  <p key={h} style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', margin: 0, letterSpacing: '0.5px' }}>{h}</p>
                ))}
              </div>
              {materials.map((row, i) => {
                const rowTotal = (parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0);
                return (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1.2fr 1fr 36px', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                    <input style={inputSt} value={row.item} onChange={e => updateMaterial(i, 'item', e.target.value)} placeholder="Paint" />
                    <input style={inputSt} value={row.description} onChange={e => updateMaterial(i, 'description', e.target.value)} placeholder="Interior wall paint" />
                    <input style={inputSt} type="number" value={row.quantity} onChange={e => updateMaterial(i, 'quantity', e.target.value)} placeholder="0" />
                    <input style={inputSt} type="number" value={row.unit_price} onChange={e => updateMaterial(i, 'unit_price', e.target.value)} placeholder="0.00" />
                    <p style={{ color: '#059669', fontWeight: 'bold', fontSize: '13px', margin: 0 }}>${rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
                    {materials.length > 1 && <button onClick={() => setMaterials(p => p.filter((_, idx) => idx !== i))} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px', padding: 0 }}>✕</button>}
                  </div>
                );
              })}
              <div style={{ textAlign: 'right', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e2e8f0' }}>
                <p style={{ color: '#475569', fontSize: '13px', margin: 0 }}>Materials Subtotal: <strong style={{ color: '#059669' }}>${materialsTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong></p>
              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)', marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>
                <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: 0 }}>👷 Labor</h2>
                <button onClick={() => setLabor(p => [...p, { service: '', description: '', quantity: '', cost: '' }])}
                  style={{ padding: '6px 14px', borderRadius: '8px', background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.3)', color: '#059669', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>
                  + Add Row
                </button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1.2fr 1fr 36px', gap: '8px', marginBottom: '8px' }}>
                {['Service', 'Description', 'Qty', 'Cost', 'Total', ''].map(h => (
                  <p key={h} style={{ color: '#94a3b8', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', margin: 0, letterSpacing: '0.5px' }}>{h}</p>
                ))}
              </div>
              {labor.map((row, i) => {
                const rowTotal = (parseFloat(row.quantity) || 0) * (parseFloat(row.cost) || 0);
                return (
                  <div key={i} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1.2fr 1fr 36px', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                    <input style={inputSt} value={row.service} onChange={e => updateLabor(i, 'service', e.target.value)} placeholder="Installation" />
                    <input style={inputSt} value={row.description} onChange={e => updateLabor(i, 'description', e.target.value)} placeholder="Flooring installation" />
                    <input style={inputSt} type="number" value={row.quantity} onChange={e => updateLabor(i, 'quantity', e.target.value)} placeholder="0" />
                    <input style={inputSt} type="number" value={row.cost} onChange={e => updateLabor(i, 'cost', e.target.value)} placeholder="0.00" />
                    <p style={{ color: '#059669', fontWeight: 'bold', fontSize: '13px', margin: 0 }}>${rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
                    {labor.length > 1 && <button onClick={() => setLabor(p => p.filter((_, idx) => idx !== i))} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '16px', padding: 0 }}>✕</button>}
                  </div>
                );
              })}
              <div style={{ textAlign: 'right', marginTop: '12px', paddingTop: '12px', borderTop: '1px solid #e2e8f0' }}>
                <p style={{ color: '#475569', fontSize: '13px', margin: 0 }}>Labor Subtotal: <strong style={{ color: '#059669' }}>${laborTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong></p>
              </div>
            </div>

            <div style={{ background: 'linear-gradient(135deg, #0f172a, #1e293b)', borderRadius: '14px', padding: '20px 28px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <p style={{ color: '#94a3b8', fontSize: '15px', margin: 0, fontWeight: '600' }}>TOTAL ESTIMATE</p>
              <p style={{ color: '#10b981', fontSize: '28px', fontWeight: 'bold', margin: 0 }}>${grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <button onClick={() => setStep(1)} style={{ padding: '13px', borderRadius: '10px', background: '#fff', border: '2px solid #e2e8f0', color: '#64748b', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>← Back</button>
              <button onClick={() => setStep(3)} style={{ padding: '13px', borderRadius: '10px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer' }}>Next: Terms →</button>
            </div>
          </div>
        )}

        {step === 3 && (
          <div style={{ background: '#fff', borderRadius: '14px', padding: '28px', border: '1px solid #e2e8f0', boxShadow: '0 2px 12px rgba(0,0,0,0.05)' }}>
            <h2 style={{ color: '#0f172a', fontSize: '17px', fontWeight: 'bold', margin: '0 0 8px', borderBottom: '2px solid #10b981', paddingBottom: '10px' }}>📄 Terms & Conditions</h2>
            <p style={{ color: '#64748b', fontSize: '13px', margin: '0 0 16px' }}>These terms will appear at the bottom of the printed estimate. You can edit them for each project.</p>
            <textarea style={{ ...inputSt, minHeight: '180px', resize: 'vertical', lineHeight: '1.7' }} value={terms} onChange={e => setTerms(e.target.value)} placeholder="Enter your terms and conditions..." />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setStep(2)} style={{ padding: '13px', borderRadius: '10px', background: '#fff', border: '2px solid #e2e8f0', color: '#64748b', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>← Back</button>
              <button onClick={handleSave} disabled={saving}
                style={{ padding: '13px', borderRadius: '10px', background: saving ? 'rgba(16,185,129,0.5)' : 'linear-gradient(135deg, #10b981, #059669)', border: 'none', color: 'white', fontSize: '15px', fontWeight: 'bold', cursor: saving ? 'not-allowed' : 'pointer' }}>
                {saving ? '⏳ Saving...' : isEdit ? '💾 Save Changes' : '💾 Save Estimate'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function ViewEstimate({ estimateId, onBack, onEdit }) {
  const [estimate, setEstimate] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [labor, setLabor] = useState([]);
  const [loading, setLoading] = useState(true);
  const [docType, setDocType] = useState('ESTIMATE');
  const [sending, setSending] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchData(); }, [estimateId]);

  const fetchData = async () => {
    setLoading(true);
    const [{ data: est }, { data: mats }, { data: lab }] = await Promise.all([
      supabase.from('estimates').select('*').eq('id', estimateId).single(),
      supabase.from('estimate_materials').select('*').eq('estimate_id', estimateId),
      supabase.from('estimate_labor').select('*').eq('estimate_id', estimateId),
    ]);
    setEstimate(est);
    setMaterials(mats || []);
    setLabor(lab || []);
    setDocType(est?.document_type || 'ESTIMATE');
    setLoading(false);
  };

  const toggleDocType = async () => {
    const newType = docType === 'ESTIMATE' ? 'INVOICE' : 'ESTIMATE';
    setDocType(newType);
    await supabase.from('estimates').update({ document_type: newType }).eq('id', estimateId);
  };

  const fmtDate = (d) => d
    ? new Date(d + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
    : null;

  const handleEmail = async () => {
    if (!estimate?.client_email) {
      alert('No email address for this client.');
      return;
    }
    setSending(true);
    try {
      let jsPDFLib = window.jspdf;
      if (!jsPDFLib) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
        jsPDFLib = window.jspdf;
      }
      const { jsPDF } = jsPDFLib;

      const doc = new jsPDF({ unit: 'pt', format: 'letter' });
      const W = doc.internal.pageSize.getWidth();
      const margin = 40;
      const colW = W - margin * 2;
      let y = 0;

      const fmtMoney = (n) => `$${(parseFloat(n)||0).toLocaleString('en-US',{minimumFractionDigits:2})}`;
      const matRowTotal = (m) => (parseFloat(m.quantity)||0)*(parseFloat(m.unit_price)||0);
      const labRowTotal = (l) => (parseFloat(l.quantity)||0)*(parseFloat(l.cost)||0);

      const startDateText = estimate.start_date ? fmtDate(estimate.start_date) : 'TBD';
      const finishDateText = estimate.finish_date ? fmtDate(estimate.finish_date) : null;

      // Header background
      doc.setFillColor(15, 23, 42);
      doc.rect(0, 0, W, 110, 'F');

      doc.setFont('helvetica','bold');
      doc.setFontSize(13);
      doc.setTextColor(16, 185, 129);
      doc.text('AMANCIO REMODELING', margin, 30);

      doc.setFont('helvetica','normal');
      doc.setFontSize(9);
      doc.setTextColor(148, 163, 184);
      doc.text('(702) 576-1958', margin, 46);
      doc.text('amancioremodelingllc@gmail.com', margin, 58);
      doc.text('Las Vegas, Nevada', margin, 70);

      doc.setFont('helvetica','bold');
      doc.setFontSize(20);
      doc.setTextColor(16, 185, 129);
      doc.text(docType, W - margin, 30, { align: 'right' });

      doc.setFontSize(14);
      doc.setTextColor(241, 245, 249);
      doc.text(estimate.folio, W - margin, 48, { align: 'right' });

      doc.setFont('helvetica','normal');
      doc.setFontSize(9);
      doc.setTextColor(100, 116, 139);
      const createdDate = new Date(estimate.created_at).toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
      doc.text(`Date: ${createdDate}`, W - margin, 63, { align: 'right' });
      if (estimate.start_date) doc.text(`Start: ${startDateText}`, W - margin, 75, { align: 'right' });
      if (finishDateText) doc.text(`Est. Finish: ${finishDateText}`, W - margin, 87, { align: 'right' });

      y = 125;

      // Client + Project boxes
      doc.setFillColor(248, 250, 252);
      doc.roundedRect(margin, y, colW/2 - 8, 80, 4, 4, 'F');
      doc.roundedRect(margin + colW/2 + 8, y, colW/2 - 8, 80, 4, 4, 'F');

      doc.setFont('helvetica','bold');
      doc.setFontSize(8);
      doc.setTextColor(16, 185, 129);
      doc.text('CLIENT INFORMATION', margin + 10, y + 16);
      doc.text('PROJECT DETAILS', margin + colW/2 + 18, y + 16);

      doc.setFont('helvetica','bold');
      doc.setFontSize(10);
      doc.setTextColor(15, 23, 42);
      doc.text(estimate.client_name || '', margin + 10, y + 32);
      doc.text(estimate.type || '', margin + colW/2 + 18, y + 32);

      doc.setFont('helvetica','normal');
      doc.setFontSize(9);
      doc.setTextColor(71, 85, 105);
      if (estimate.client_address) doc.text(estimate.client_address, margin + 10, y + 46);
      if (estimate.client_phone)   doc.text(estimate.client_phone,   margin + 10, y + 58);
      if (estimate.client_email)   doc.text(estimate.client_email,   margin + 10, y + 70);
      if (estimate.start_date)     doc.text(`Start: ${startDateText}`, margin + colW/2 + 18, y + 46);
      if (finishDateText)          doc.text(`Est. Finish: ${finishDateText}`, margin + colW/2 + 18, y + 58);

      y += 96;



      const drawTable = (headers, rows, colWidths) => {
        const rowH = 24;
        const tableW = colWidths.reduce((a,b) => a+b, 0);
        if (y + rowH * (rows.length + 2) > doc.internal.pageSize.getHeight() - 60) {
          doc.addPage();
          y = 40;
        }
        doc.setFillColor(15, 23, 42);
        doc.rect(margin, y, tableW, rowH, 'F');
        doc.setFont('helvetica','bold');
        doc.setFontSize(9);
        doc.setTextColor(241, 245, 249);
        let x = margin;
        headers.forEach((h, i) => {
          const align = i >= 2 ? 'right' : 'left';
          const tx = align === 'right' ? x + colWidths[i] - 6 : x + 8;
          doc.text(h, tx, y + 16, { align });
          x += colWidths[i];
        });
        y += rowH;
        rows.forEach((row, ri) => {
          doc.setFillColor(ri % 2 === 0 ? 255 : 248, ri % 2 === 0 ? 255 : 250, ri % 2 === 0 ? 255 : 252);
          doc.rect(margin, y, tableW, rowH, 'F');
          doc.setDrawColor(226, 232, 240);
          doc.rect(margin, y, tableW, rowH, 'S');
          doc.setFont('helvetica','normal');
          doc.setFontSize(9);
          let cx = margin;
          row.forEach((cell, ci) => {
            const align = ci >= 2 ? 'right' : 'left';
            const tx = align === 'right' ? cx + colWidths[ci] - 6 : cx + 8;
            if (ci === row.length - 1) doc.setTextColor(5, 150, 105);
            else if (ci === 0) doc.setTextColor(30, 41, 59);
            else doc.setTextColor(71, 85, 105);
            doc.text(String(cell), tx, y + 16, { align });
            cx += colWidths[ci];
          });
          y += rowH;
        });
        doc.setFillColor(240, 253, 244);
        doc.rect(margin, y, tableW, rowH, 'F');
        doc.setFont('helvetica','bold');
        doc.setFontSize(9);
        doc.setTextColor(22, 101, 52);
        doc.text('Subtotal', margin + tableW - colWidths[colWidths.length-1] - 6, y + 16, { align: 'right' });
        doc.setTextColor(5, 150, 105);
        const subtotal = rows.reduce((s, r) => s + (parseFloat(r[r.length-1].replace('$','').replace(/,/g,''))||0), 0);
        doc.text(fmtMoney(subtotal), margin + tableW - 6, y + 16, { align: 'right' });
        y += rowH + 16;
      };

      if (materials.length > 0) {
        doc.setFont('helvetica','bold');
        doc.setFontSize(11);
        doc.setTextColor(15, 23, 42);
        doc.text('Materials', margin, y);
        y += 14;
        const matCols = [colW*0.22, colW*0.28, colW*0.12, colW*0.18, colW*0.20];
        const matRows = materials.map(m => [m.item || '', m.description || '', String(m.quantity || 0), fmtMoney(m.unit_price), fmtMoney(matRowTotal(m))]);
        drawTable(['Item','Description','Qty','Unit Price','Total'], matRows, matCols);
      }

      if (labor.length > 0) {
        doc.setFont('helvetica','bold');
        doc.setFontSize(11);
        doc.setTextColor(15, 23, 42);
        doc.text('Labor', margin, y);
        y += 14;
        const labCols = [colW*0.22, colW*0.28, colW*0.12, colW*0.18, colW*0.20];
        const labRows = labor.map(l => [l.service || '', l.description || '', String(l.quantity || 0), fmtMoney(l.cost), fmtMoney(labRowTotal(l))]);
        drawTable(['Service','Description','Qty','Cost','Total'], labRows, labCols);
      }

      if (y + 50 > doc.internal.pageSize.getHeight() - 60) { doc.addPage(); y = 40; }
      doc.setFillColor(15, 23, 42);
      doc.roundedRect(margin, y, colW, 44, 6, 6, 'F');
      doc.setFont('helvetica','bold');
      doc.setFontSize(12);
      doc.setTextColor(148, 163, 184);
      doc.text(`TOTAL ${docType}`, margin + 16, y + 27);
      doc.setFontSize(18);
      doc.setTextColor(16, 185, 129);
      doc.text(fmtMoney(estimate.total), W - margin - 16, y + 27, { align: 'right' });
      y += 60;

      if (estimate.terms) {
        if (y + 60 > doc.internal.pageSize.getHeight() - 40) { doc.addPage(); y = 40; }
        doc.setDrawColor(226, 232, 240);
        doc.line(margin, y, W - margin, y);
        y += 14;
        doc.setFont('helvetica','bold');
        doc.setFontSize(8);
        doc.setTextColor(71, 85, 105);
        doc.text('TERMS & CONDITIONS', margin, y);
        y += 12;
        doc.setFont('helvetica','normal');
        doc.setFontSize(8);
        doc.setTextColor(148, 163, 184);
        const termsLines = doc.splitTextToSize(estimate.terms, colW);
        doc.text(termsLines, margin, y);
      }

      const pdfBase64 = doc.output('datauristring').split(',')[1];
      const response = await fetch('/api/send-estimate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ estimate, materials, labor, pdfBase64 }),
      });
      const result = await response.json();
      if (result.error) {
        alert('Error sending email: ' + result.error);
      } else {
        alert(`✅ Email sent to ${estimate.client_email} with PDF attached!`);
      }
    } catch (err) {
      alert('Error: ' + err.message);
    }
    setSending(false);
  };

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8', fontFamily: 'Georgia, serif' }}>Loading...</div>;
  if (!estimate) return null;

  const date = new Date(estimate.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  const matRowTotal = (m) => (parseFloat(m.quantity) || 0) * (parseFloat(m.unit_price) || 0);
  const labRowTotal = (l) => (parseFloat(l.quantity) || 0) * (parseFloat(l.cost) || 0);

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <div className="no-print">
        <PortalHeader title={`Estimate ${estimate.folio}`} onBack={onBack}>
          <button onClick={toggleDocType}
            style={{ padding: '8px 18px', borderRadius: '8px', background: docType === 'ESTIMATE' ? 'rgba(245,158,11,0.2)' : 'rgba(59,130,246,0.2)', border: '1px solid', borderColor: docType === 'ESTIMATE' ? 'rgba(245,158,11,0.4)' : 'rgba(59,130,246,0.4)', color: docType === 'ESTIMATE' ? '#fbbf24' : '#60a5fa', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
            🔄 {docType === 'ESTIMATE' ? 'Switch to Invoice' : 'Switch to Estimate'}
          </button>
          <button onClick={() => onEdit(estimateId)}
            style={{ padding: '8px 18px', borderRadius: '8px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)', color: '#cbd5e1', fontSize: '13px', cursor: 'pointer' }}>
            ✏️ Edit
          </button>
          <button onClick={handleEmail} disabled={sending}
            style={{ padding: '8px 18px', borderRadius: '8px', background: sending ? 'rgba(59,130,246,0.5)' : 'linear-gradient(135deg, #3b82f6, #2563eb)', border: 'none', color: 'white', fontSize: '13px', fontWeight: '600', cursor: sending ? 'not-allowed' : 'pointer' }}>
            {sending ? '⏳ Sending...' : '📧 Email'}
          </button>
          <button onClick={() => window.print()}
            style={{ padding: '8px 18px', borderRadius: '8px', background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', border: 'none', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
            🖨️ Print / PDF
          </button>
        </PortalHeader>
      </div>

      <div style={{ maxWidth: '860px', margin: '28px auto', padding: '0 24px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #e2e8f0' }}>
          <div style={{ background: 'linear-gradient(135deg, #0f172a, #1e293b)', padding: '28px 36px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <img src={logoAmancio} alt="Amancio Remodeling" style={{ height: '120px', display: 'block' }} />
              <div>
                <p style={{ color: '#94a3b8', fontSize: '12px', margin: '2px 0' }}>📞 (702) 576-1958</p>
                <p style={{ color: '#94a3b8', fontSize: '12px', margin: '2px 0' }}>📧 amancioremodelingllc@gmail.com</p>
                <p style={{ color: '#94a3b8', fontSize: '12px', margin: '2px 0' }}>📍 Las Vegas, Nevada</p>
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <p style={{ color: '#10b981', fontSize: '28px', fontWeight: '900', textTransform: 'uppercase', letterSpacing: '4px', margin: '0 0 8px' }}>{docType}</p>
              <p style={{ color: '#f1f5f9', fontSize: '24px', fontWeight: 'bold', margin: '0 0 4px' }}>{estimate.folio}</p>
              <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 2px' }}>Date: {date}</p>
              {estimate.start_date && <p style={{ color: '#64748b', fontSize: '12px', margin: '0 0 2px' }}>Start: {fmtDate(estimate.start_date)}</p>}
              {estimate.finish_date && <p style={{ color: '#64748b', fontSize: '12px', margin: 0 }}>Est. Finish: {fmtDate(estimate.finish_date)}</p>}
            </div>
          </div>

          <div style={{ padding: '28px 36px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '28px' }}>
              <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '16px' }}>
                <p style={{ color: '#10b981', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 10px' }}>Client Information</p>
                <p style={{ color: '#0f172a', fontSize: '15px', fontWeight: 'bold', margin: '0 0 4px' }}>{estimate.client_name}</p>
                {estimate.client_address && <p style={{ color: '#475569', fontSize: '13px', margin: '0 0 3px' }}>📍 {estimate.client_address}</p>}
                {estimate.client_phone && <p style={{ color: '#475569', fontSize: '13px', margin: '0 0 3px' }}>📞 {estimate.client_phone}</p>}
                {estimate.client_email && <p style={{ color: '#475569', fontSize: '13px', margin: 0 }}>📧 {estimate.client_email}</p>}
              </div>
              <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '16px' }}>
                <p style={{ color: '#10b981', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 10px' }}>Project Details</p>
                <p style={{ color: '#0f172a', fontSize: '15px', fontWeight: 'bold', margin: '0 0 4px' }}>{estimate.type}</p>
                {estimate.start_date && <p style={{ color: '#475569', fontSize: '13px', margin: '0 0 3px' }}>🗓 Start: {fmtDate(estimate.start_date)}</p>}
                {estimate.finish_date && <p style={{ color: '#475569', fontSize: '13px', margin: 0 }}>🏁 Est. Finish: {fmtDate(estimate.finish_date)}</p>}
              </div>
            </div>



            {materials.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <p style={{ color: '#0f172a', fontSize: '14px', fontWeight: '700', margin: '0 0 10px' }}>Materials</p>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ background: '#0f172a' }}>
                      {['Item', 'Description', 'Quantity', 'Unit Price', 'Total'].map(h => (
                        <th key={h} style={{ padding: '10px 12px', color: '#f1f5f9', fontWeight: '600', textAlign: h === 'Item' || h === 'Description' ? 'left' : 'right', fontSize: '12px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {materials.map((m, i) => (
                      <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <td style={{ padding: '10px 12px', color: '#1e293b', fontWeight: '500' }}>{m.item}</td>
                        <td style={{ padding: '10px 12px', color: '#475569' }}>{m.description}</td>
                        <td style={{ padding: '10px 12px', color: '#475569', textAlign: 'right' }}>{m.quantity}</td>
                        <td style={{ padding: '10px 12px', color: '#475569', textAlign: 'right' }}>${parseFloat(m.unit_price).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                        <td style={{ padding: '10px 12px', color: '#059669', fontWeight: '600', textAlign: 'right' }}>${matRowTotal(m).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                      </tr>
                    ))}
                    <tr style={{ background: '#f0fdf4' }}>
                      <td colSpan={4} style={{ padding: '10px 12px', color: '#166534', fontWeight: '700', textAlign: 'right' }}>Materials Subtotal</td>
                      <td style={{ padding: '10px 12px', color: '#059669', fontWeight: '700', textAlign: 'right' }}>${materials.reduce((s, m) => s + matRowTotal(m), 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            {labor.length > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <p style={{ color: '#0f172a', fontSize: '14px', fontWeight: '700', margin: '0 0 10px' }}>Labor</p>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ background: '#0f172a' }}>
                      {['Service', 'Description', 'Qty', 'Cost', 'Total'].map(h => (
                        <th key={h} style={{ padding: '10px 12px', color: '#f1f5f9', fontWeight: '600', textAlign: h === 'Service' || h === 'Description' ? 'left' : 'right', fontSize: '12px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {labor.map((l, i) => (
                      <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                        <td style={{ padding: '10px 12px', color: '#1e293b', fontWeight: '500' }}>{l.service}</td>
                        <td style={{ padding: '10px 12px', color: '#475569' }}>{l.description}</td>
                        <td style={{ padding: '10px 12px', color: '#475569', textAlign: 'right' }}>{l.quantity}</td>
                        <td style={{ padding: '10px 12px', color: '#475569', textAlign: 'right' }}>${parseFloat(l.cost).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                        <td style={{ padding: '10px 12px', color: '#059669', fontWeight: '600', textAlign: 'right' }}>${labRowTotal(l).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                      </tr>
                    ))}
                    <tr style={{ background: '#f0fdf4' }}>
                      <td colSpan={4} style={{ padding: '10px 12px', color: '#166534', fontWeight: '700', textAlign: 'right' }}>Labor Subtotal</td>
                      <td style={{ padding: '10px 12px', color: '#059669', fontWeight: '700', textAlign: 'right' }}>${labor.reduce((s, l) => s + labRowTotal(l), 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

            <div style={{ background: 'linear-gradient(135deg, #0f172a, #1e293b)', borderRadius: '12px', padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
              <p style={{ color: '#94a3b8', fontSize: '15px', fontWeight: '600', margin: 0 }}>TOTAL ESTIMATE</p>
              <p style={{ color: '#10b981', fontSize: '26px', fontWeight: 'bold', margin: 0 }}>${parseFloat(estimate.total).toLocaleString('en-US', { minimumFractionDigits: 2 })}</p>
            </div>

            {estimate.terms && (
              <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px' }}>
                <p style={{ color: '#475569', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', margin: '0 0 8px' }}>Terms & Conditions</p>
                <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0, lineHeight: '1.8', whiteSpace: 'pre-line' }}>{estimate.terms}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <style>{`@media print { .no-print { display: none !important; } body { background: white !important; } }`}</style>
    </div>
  );
}

// ============================================================
// GALLERY MANAGER
// ============================================================
function GalleryManager({ onBack }) {
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const fileInputRef = React.useRef();

  const BUCKET = 'gallery';

  useEffect(() => { fetchImages(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchImages = async () => {
    const { data, error } = await supabase.storage.from(BUCKET).list('', { sortBy: { column: 'created_at', order: 'desc' } });
    if (error) { console.error(error); return; }
    const files = (data || []).filter(f => f.name !== '.emptyFolderPlaceholder');
    const withUrls = files.map(f => {
      const { data: urlData } = supabase.storage.from(BUCKET).getPublicUrl(f.name);
      return { name: f.name, url: urlData.publicUrl, size: f.metadata?.size };
    });
    setImages(withUrls);
  };

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    setUploadError('');
    for (const file of files) {
      if (!file.type.startsWith('image/')) { setUploadError('Only image files are allowed.'); continue; }
      if (file.size > 10 * 1024 * 1024) { setUploadError('Each image must be under 10MB.'); continue; }
      const ext = file.name.split('.').pop();
      const fileName = `photo_${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
      const { error } = await supabase.storage.from(BUCKET).upload(fileName, file, { cacheControl: '3600', upsert: false });
      if (error) setUploadError(`Error uploading ${file.name}: ${error.message}`);
    }
    setUploading(false);
    fileInputRef.current.value = '';
    fetchImages();
  };

  const handleDelete = async (name) => {
    setDeleting(name);
    const { error } = await supabase.storage.from(BUCKET).remove([name]);
    if (error) { setUploadError(`Error deleting: ${error.message}`); }
    setDeleteConfirm(null);
    setDeleting(null);
    fetchImages();
  };

  const fmtSize = (bytes) => {
    if (!bytes) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: 'Georgia, serif' }}>
      <PortalHeader title="Gallery Manager" onBack={onBack} backLabel="← Dashboard" />

      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '32px 24px' }}>
        {/* Upload Area */}
        <div style={{ background: '#fff', border: '2px dashed #d1fae5', borderRadius: '16px', padding: '32px', textAlign: 'center', marginBottom: '32px', cursor: 'pointer' }}
          onClick={() => fileInputRef.current?.click()}
          onDragOver={e => { e.preventDefault(); e.currentTarget.style.borderColor = '#10b981'; e.currentTarget.style.background = '#f0fdf4'; }}
          onDragLeave={e => { e.currentTarget.style.borderColor = '#d1fae5'; e.currentTarget.style.background = '#fff'; }}
          onDrop={e => { e.preventDefault(); e.currentTarget.style.borderColor = '#d1fae5'; e.currentTarget.style.background = '#fff'; const dt = e.dataTransfer; fileInputRef.current.files = dt.files; handleUpload({ target: { files: dt.files } }); }}>
          <input ref={fileInputRef} type="file" accept="image/*" multiple onChange={handleUpload} style={{ display: 'none' }} />
          {uploading ? (
            <div>
              <p style={{ fontSize: '36px', margin: '0 0 8px' }}>⏳</p>
              <p style={{ color: '#10b981', fontWeight: '600', margin: 0 }}>Uploading images...</p>
            </div>
          ) : (
            <div>
              <p style={{ fontSize: '36px', margin: '0 0 8px' }}>📸</p>
              <p style={{ color: '#0f172a', fontWeight: '700', fontSize: '16px', margin: '0 0 4px' }}>Click or drag images here to upload</p>
              <p style={{ color: '#94a3b8', fontSize: '13px', margin: 0 }}>JPG, PNG, WEBP — up to 10MB each — multiple files supported</p>
            </div>
          )}
        </div>

        {uploadError && (
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#dc2626', fontSize: '13px' }}>
            ⚠️ {uploadError}
          </div>
        )}

        {/* Stats bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h2 style={{ color: '#0f172a', fontSize: '18px', fontWeight: 'bold', margin: 0 }}>
            Gallery Photos <span style={{ color: '#64748b', fontSize: '14px', fontWeight: 'normal' }}>({images.length} images)</span>
          </h2>
          <p style={{ color: '#94a3b8', fontSize: '12px', margin: 0 }}>These images appear on your website's "Our Work" section</p>
        </div>

        {/* Grid */}
        {images.length === 0 && !uploading ? (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#94a3b8' }}>
            <p style={{ fontSize: '48px', margin: '0 0 12px' }}>🖼️</p>
            <p style={{ fontSize: '15px', margin: 0 }}>No images yet. Upload your first project photo above!</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '16px' }}>
            {images.map((img) => (
              <div key={img.name} style={{ background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', position: 'relative' }}>
                <div style={{ position: 'relative', paddingTop: '66%', background: '#f1f5f9', overflow: 'hidden' }}>
                  <img src={img.url} alt={img.name} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: '10px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                  <div style={{ minWidth: 0 }}>
                    <p style={{ color: '#475569', fontSize: '11px', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{img.name.replace(/^photo_\d+_[a-z0-9]+\./, 'photo.')}</p>
                    {img.size && <p style={{ color: '#94a3b8', fontSize: '10px', margin: '2px 0 0' }}>{fmtSize(img.size)}</p>}
                  </div>
                  {deleteConfirm === img.name ? (
                    <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
                      <button onClick={() => handleDelete(img.name)} disabled={deleting === img.name}
                        style={{ padding: '5px 10px', borderRadius: '6px', background: '#ef4444', border: 'none', color: '#fff', fontSize: '11px', fontWeight: '700', cursor: 'pointer' }}>
                        {deleting === img.name ? '...' : 'Yes, delete'}
                      </button>
                      <button onClick={() => setDeleteConfirm(null)}
                        style={{ padding: '5px 10px', borderRadius: '6px', background: '#f1f5f9', border: '1px solid #e2e8f0', color: '#475569', fontSize: '11px', cursor: 'pointer' }}>
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button onClick={() => setDeleteConfirm(img.name)}
                      style={{ padding: '5px 10px', borderRadius: '6px', background: '#fef2f2', border: '1px solid #fecaca', color: '#ef4444', fontSize: '11px', fontWeight: '600', cursor: 'pointer', flexShrink: 0 }}>
                      🗑 Delete
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: '32px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: '12px', padding: '16px 20px' }}>
          <p style={{ color: '#92400e', fontSize: '13px', margin: 0, lineHeight: '1.6' }}>
            <strong>💡 Tip:</strong> Upload your best project photos here. They will automatically appear on your website's gallery. For best results, use landscape photos (wider than tall). The 6 most recent photos are shown on the website.
          </p>
        </div>
      </div>
    </div>
  );
}

export default function AdminPortal() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [screen, setScreen] = useState('dashboard');
  const [selectedId, setSelectedId] = useState(null);
  const [preselectedClientId, setPreselectedClientId] = useState(null);

  if (!loggedIn) return <AdminLogin onLogin={() => setLoggedIn(true)} />;

  if (screen === 'dashboard') return <Dashboard onNavigate={setScreen} onLogout={() => setLoggedIn(false)} />;

  if (screen === 'estimates') return <EstimateList onNew={() => { setSelectedId(null); setPreselectedClientId(null); setScreen('estimate-form'); }} onView={id => { setSelectedId(id); setScreen('estimate-view'); }} onBack={() => setScreen('dashboard')} />;
  if (screen === 'estimate-form') return <EstimateForm estimateId={selectedId} preselectedClientId={preselectedClientId} onSaved={id => { setSelectedId(id); setScreen('estimate-view'); }} onBack={() => setScreen(selectedId ? 'estimate-view' : 'estimates')} />;
  if (screen === 'estimate-view') return <ViewEstimate estimateId={selectedId} onBack={() => setScreen('estimates')} onEdit={id => { setSelectedId(id); setScreen('estimate-form'); }} />;

  if (screen === 'clients') return <ClientList onNew={() => { setSelectedId(null); setScreen('client-form'); }} onView={id => { setSelectedId(id); setScreen('client-detail'); }} onBack={() => setScreen('dashboard')} />;
  if (screen === 'client-form') return <ClientForm clientId={selectedId} onSaved={() => setScreen('clients')} onBack={() => setScreen('clients')} />;
  if (screen === 'client-detail') return <ClientDetail clientId={selectedId} onBack={() => setScreen('clients')} onNewEstimate={clientId => { setPreselectedClientId(clientId); setSelectedId(null); setScreen('estimate-form'); }} onViewEstimate={id => { setSelectedId(id); setScreen('estimate-view'); }} />;

  if (screen === 'gallery') return <GalleryManager onBack={() => setScreen('dashboard')} />;

  return null;
}